import type { TxView } from '@shared/api-types';

/** True when the processor recorded the request (Applied, or the same request seen before). */
export const txApplied = (x: Pick<TxView, 'processingStatus' | 'outcomeCode'>): boolean => x.processingStatus === 'Completed' && (x.outcomeCode === 'Applied' || x.outcomeCode === 'Duplicate Ignored');

/**
 * What to say right after a press (1.6.0), chosen by the answer and not by a setting: "Recorded." / "Rejected: …"
 * when the request came back closed (the app's engine answered with the press), `sent` — the "answers in a few
 * minutes" sentence — while it is still with the scheduler.
 */
export function pressWords(t: (k: string, o?: Record<string, unknown>) => string, res: { status: string; transaction: Pick<TxView, 'open' | 'processingStatus' | 'outcomeCode' | 'outcomeMessage'> }, sent: string, recorded?: string): string {
  if (res.status === 'duplicate') return t('tx.duplicate');
  const x = res.transaction;
  if (x.open) return sent;
  return txApplied(x) ? (recorded ?? t('tx.recorded')) : t('tx.rejected', { words: x.outcomeMessage ?? t('tx.closedNoMessage', { status: x.processingStatus }) });
}
